import axios from '../../axios';
import dayjs from 'dayjs';

export type ServiceResponse = {
  id: string;
  clientCode: string;
  clientName: string;
  taxId: string;
  balance: string;
  reconciliationStatus: string;
  documentCount: string;
  type: string;
  status: statusEnum;
};

type statusEnum = 'AGREED' | 'NOT_AGREED' | 'OTHER';

export type ServiceRequest = {
  dates: dayjs.Dayjs[];
};

export default async function getExtract(
  params: ServiceRequest
): Promise<ServiceResponse[]> {
  let res = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/financial-operation/extract`,
    {
      params: {
        startDate: params.dates[0].isAfter(params.dates[1])
          ? params.dates[1].toISOString()
          : params.dates[0].toISOString(),
        endDate: params.dates[0].isAfter(params.dates[1])
          ? params.dates[0].toISOString()
          : params.dates[1].toISOString(),
      },
    }
  );
  return res.data;
}
